const body = document.body;
const menuToggle = document.querySelector(".mobile-menu-toggle");
const submenuToggle = document.querySelector(".submenu-toggle");
const submenuItem = document.querySelector(".has-submenu");
const nav = document.querySelector(".primary-nav");
const desktopQuery = window.matchMedia("(min-width: 921px)");
const languageForm = document.querySelector(".language-form");

languageForm?.addEventListener("submit", () => {
  const returnTo = languageForm.querySelector('input[name="return_to"]');
  if (returnTo instanceof HTMLInputElement) {
    returnTo.value = `${window.location.pathname}${window.location.search}`;
  }
});

function setMenuOpen(open) {
  body.classList.toggle("mobile-nav-open", open);
  menuToggle?.setAttribute("aria-expanded", String(open));
  if (!open) {
    submenuItem?.classList.remove("submenu-open");
    submenuToggle?.setAttribute("aria-expanded", "false");
  }
}

function setSubmenuOpen(open) {
  submenuItem?.classList.toggle("submenu-open", open);
  submenuToggle?.setAttribute("aria-expanded", String(open));
}

menuToggle?.addEventListener("click", () => {
  setMenuOpen(!body.classList.contains("mobile-nav-open"));
});

submenuToggle?.addEventListener("click", (event) => {
  event.preventDefault();
  setSubmenuOpen(!submenuItem?.classList.contains("submenu-open"));
});

nav?.addEventListener("click", (event) => {
  const target = event.target;
  if (target instanceof HTMLAnchorElement && !desktopQuery.matches) {
    setMenuOpen(false);
  }
});

document.addEventListener("click", (event) => {
  if (!desktopQuery.matches) return;
  const target = event.target;
  if (target instanceof Node && submenuItem?.contains(target)) return;
  setSubmenuOpen(false);
});

window.addEventListener("resize", () => {
  if (desktopQuery.matches) setMenuOpen(false);
});

const customPaymentForm = document.querySelector("#custom-payment-form");
const customPaymentAmount = document.querySelector("#custom-payment-amount");
const customPaymentQuantity = document.querySelector("#custom-payment-quantity");
const customPaymentQuotedProperty = document.querySelector("#custom-payment-quoted-property");

function syncCustomPaymentAmount() {
  if (!(customPaymentAmount instanceof HTMLInputElement)) return;
  const amount = Number(customPaymentAmount.value);
  const wholeDollarAmount = Number.isFinite(amount) ? Math.max(1, Math.round(amount)) : 1;

  if (customPaymentQuantity instanceof HTMLInputElement) {
    customPaymentQuantity.value = String(wholeDollarAmount);
  }
  if (customPaymentQuotedProperty instanceof HTMLInputElement) {
    customPaymentQuotedProperty.value = `USD $${wholeDollarAmount}`;
  }
}

customPaymentAmount?.addEventListener("input", syncCustomPaymentAmount);
customPaymentForm?.addEventListener("submit", syncCustomPaymentAmount);

function showCustomPaymentMessage(message) {
  if (!customPaymentForm) return;
  let messageBox = customPaymentForm.querySelector(".custom-payment-message");
  if (!messageBox) {
    messageBox = document.createElement("p");
    messageBox.className = "custom-payment-message";
    messageBox.setAttribute("role", "alert");
    messageBox.style.cssText = "margin:0;color:#b42318;font-size:14px;font-weight:700;";
    customPaymentForm.appendChild(messageBox);
  }
  messageBox.textContent = message;
}

customPaymentForm?.addEventListener("submit", async (event) => {
  event.preventDefault();
  syncCustomPaymentAmount();

  if (!(customPaymentAmount instanceof HTMLInputElement)) return;
  const amount = Number(customPaymentAmount.value);
  if (!Number.isFinite(amount) || amount < 1) {
    showCustomPaymentMessage("Please enter the quoted amount before continuing.");
    return;
  }

  const submitButton = customPaymentForm.querySelector('button[type="submit"]');
  const originalText = submitButton?.textContent || "";
  if (submitButton instanceof HTMLButtonElement) {
    submitButton.disabled = true;
    submitButton.textContent = "Preparing checkout...";
  }

  try {
    await fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } });
    const formData = new FormData(customPaymentForm);
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    });

    if (!response.ok) {
      let errorMessage = "We could not prepare checkout. Please contact us before paying.";
      try {
        const data = await response.json();
        errorMessage = data.description || data.message || errorMessage;
      } catch (error) {
        // Keep the default message.
      }
      throw new Error(errorMessage);
    }

    window.location.href = "/checkout";
  } catch (error) {
    showCustomPaymentMessage(error instanceof Error ? error.message : "We could not prepare checkout. Please contact us before paying.");
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  }
});

function addBankTransferDetails() {
  if (!window.location.pathname.includes("/pages/payment")) return;
  const paymentLayout = document.querySelector(".payment-layout");
  if (!paymentLayout || document.querySelector(".bank-transfer-card")) return;

  const style = document.createElement("style");
  style.textContent = `
    .bank-transfer-card {
      grid-column: 2;
      padding: 28px;
      border: 1px solid rgba(22, 135, 217, 0.2);
      border-radius: 8px;
      background: #ffffff;
      box-shadow: 0 18px 42px rgba(17, 43, 63, 0.08);
    }
    .bank-transfer-card h3 {
      margin-bottom: 12px;
    }
    .bank-detail-list {
      display: grid;
      gap: 12px;
      margin: 22px 0 0;
    }
    .bank-detail-list div {
      display: grid;
      gap: 4px;
      padding: 14px 16px;
      border: 1px solid var(--line);
      border-radius: 8px;
      background: var(--soft);
    }
    .bank-detail-list dt {
      color: var(--blue-dark);
      font-size: 12px;
      font-weight: 800;
      text-transform: uppercase;
    }
    .bank-detail-list dd {
      margin: 0;
      color: var(--ink);
      font-weight: 700;
      overflow-wrap: anywhere;
    }
    @media (max-width: 1040px) {
      .bank-transfer-card {
        grid-column: auto;
      }
    }
  `;
  document.head.appendChild(style);

  const card = document.createElement("div");
  card.className = "bank-transfer-card";
  card.innerHTML = `
    <p class="eyebrow">Bank Transfer</p>
    <h3>Company bank details for quoted payments.</h3>
    <p>Use bank transfer only after you receive a written quote from our team. Please include your case reference and send the transfer receipt by email or WhatsApp so we can match the payment to your plan.</p>
    <dl class="bank-detail-list">
      <div><dt>Company name</dt><dd>HKYUE JIA INTERNATIONAL TRADE LIMITED</dd></div>
      <div><dt>Account number</dt><dd>04061639000747</dd></div>
      <div><dt>Bank</dt><dd>Dah Sing Bank</dd></div>
      <div><dt>Bank address</dt><dd>36 Floor, Everbright Center, 108 Gloucester Road, Wanchai, Hong Kong</dd></div>
      <div><dt>SWIFT code</dt><dd>DSBAHKHH</dd></div>
    </dl>
  `;
  paymentLayout.appendChild(card);
}

addBankTransferDetails();
